import { render, staticRenderFns } from "./consumable.vue?vue&type=template&id=6c95ddb6&scoped=true&"
import script from "./consumable.vue?vue&type=script&lang=js&"
export * from "./consumable.vue?vue&type=script&lang=js&"
import style0 from "./consumable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./consumable.vue?vue&type=style&index=1&id=6c95ddb6&scoped=true&lang=css&"
import style2 from "./consumable.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c95ddb6",
  null
  
)

export default component.exports